module.exports = __webpack_public_path__ + "static/media/wizualizacja-20.a4ecbcc9.png";